// ui.form.select.js
// 自定义下拉选择控件（form-select）支持单选/多选
// 自动增强原生 <select> 元素为自定义样式的下拉组件
(function () {
  'use strict';
  
  // ==================== 配置选项 ====================
  var config = {
    // 自动增强的选择器
    selector: 'select.form-select',
    // 是否启用自动增强
    autoEnhance: true,
    // 是否在增强后隐藏原生select
    hideNative: true,
    // 自定义样式类名前缀
    classPrefix: 'form-select'
  };
  
  // ==================== 增强器部分 ====================
  
  /**
   * 生成唯一ID
   */
  function generateId() {
    return 'select-' + Math.random().toString(36).substr(2, 9);
  }
  
  /**
   * 创建自定义下拉的HTML结构
   * @param {HTMLSelectElement} nativeSelect - 原生select元素
   * @returns {HTMLElement} - 自定义下拉容器
   */
  function createCustomSelect(nativeSelect) {
    var isMultiple = nativeSelect.multiple;
    var isDisabled = nativeSelect.disabled || nativeSelect.readOnly;
    var isSearchable = nativeSelect.getAttribute('data-searchable') === 'true';
    var searchPlaceholder = nativeSelect.getAttribute('data-search-placeholder') || '搜索...';
    var placeholder = nativeSelect.getAttribute('data-placeholder') || 
                     nativeSelect.options[0]?.text || 
                     '请选择';

    // 创建容器
    var container = document.createElement('div');
    container.className = config.classPrefix;
    if (isMultiple) {
      container.setAttribute('data-multiple', 'true');
    }
    if (isDisabled) {
      container.classList.add('is-disabled');
    }
    if (isSearchable) {
      container.setAttribute('data-searchable', 'true');
    }
    container.setAttribute('data-placeholder', placeholder);
    
    // 确保原生select有ID
    if (!nativeSelect.id) {
      nativeSelect.id = generateId();
    }
    container.setAttribute('data-native-select-id', nativeSelect.id);

    // 创建触发器
    var trigger = document.createElement('div');
    trigger.className = config.classPrefix + '-trigger';
    
    var valueBox = document.createElement('div');
    valueBox.className = config.classPrefix + '-value';
    valueBox.textContent = placeholder;
    
    var arrow = document.createElement('div');
    arrow.className = config.classPrefix + '-arrow';
    // 箭头通过CSS背景图显示，不需要innerHTML
    
    trigger.appendChild(valueBox);
    trigger.appendChild(arrow);

    // 创建下拉菜单
    var dropdown = document.createElement('div');
    dropdown.className = config.classPrefix + '-dropdown';

    if (isSearchable) {
      var searchBox = document.createElement('div');
      searchBox.className = config.classPrefix + '-search';

      var searchInput = document.createElement('input');
      searchInput.type = 'text';
      searchInput.className = 'form-control ' + config.classPrefix + '-search-input';
      searchInput.placeholder = searchPlaceholder;
      searchInput.setAttribute('autocomplete', 'off');

      searchBox.appendChild(searchInput);
      dropdown.appendChild(searchBox);
    }

    // 填充选项
    Array.from(nativeSelect.options).forEach(function(option, index) {
      // 跳过占位符选项（第一个空值选项）
      var text = option.text?.trim();
      if (index === 0 && option.value === '' && !isMultiple) {
        if (!text || text === '请选择' || text.startsWith('请选择') || text === '-' || text === '---') {
          return;
        }
      }

      var optionDiv = document.createElement('div');
      optionDiv.className = config.classPrefix + '-option';
      optionDiv.setAttribute('data-value', option.value);
      optionDiv.setAttribute('data-label', text || '');
      
      if (option.disabled) {
        optionDiv.classList.add('is-disabled');
      }
      if (option.selected) {
        optionDiv.classList.add('is-selected');
      }

      if (isMultiple) {
        var checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.className = config.classPrefix + '-checkbox';
        checkbox.checked = option.selected;
        
        var span = document.createElement('span');
        span.textContent = option.text;
        
        optionDiv.appendChild(checkbox);
        optionDiv.appendChild(span);
      } else {
        optionDiv.textContent = option.text;
      }

      dropdown.appendChild(optionDiv);
    });

    // 组装
    container.appendChild(trigger);
    container.appendChild(dropdown);

    return container;
  }
  
  /**
   * 增强原生select元素
   * @param {HTMLSelectElement} nativeSelect - 原生select元素
   * @returns {HTMLElement|null} - 增强后的容器元素
   */
  function enhanceSelect(nativeSelect) {
    // 检查是否已增强
    if (nativeSelect.dataset.enhanced === 'true') {
      return nativeSelect.nextElementSibling;
    }
    
    // 检查是否禁用增强
    if (nativeSelect.dataset.noEnhance === 'true') {
      return null;
    }
    
    // 创建自定义下拉
    var customSelect = createCustomSelect(nativeSelect);
    
    // 在原生select后插入自定义下拉
    nativeSelect.parentNode.insertBefore(customSelect, nativeSelect.nextSibling);
    
    // 为容器添加增强标记类（用于CSS样式）
    customSelect.classList.add('form-select-enhanced');
    
    // 隐藏原生select（但保留在DOM中以支持表单提交）
    if (config.hideNative) {
      nativeSelect.style.position = 'absolute';
      nativeSelect.style.opacity = '0';
      nativeSelect.style.pointerEvents = 'none';
      nativeSelect.style.width = '0';
      nativeSelect.style.height = '0';
    }
    
    // 标记已增强
    nativeSelect.dataset.enhanced = 'true';
    
    return customSelect;
  }
  
  /**
   * 销毁增强
   * @param {HTMLSelectElement} nativeSelect - 原生select元素
   */
  function destroyEnhancement(nativeSelect) {
    if (nativeSelect.dataset.enhanced !== 'true') return;
    
    // 查找并移除自定义下拉
    var customSelect = nativeSelect.nextElementSibling;
    if (customSelect && customSelect.classList.contains(config.classPrefix)) {
      customSelect.remove();
    }
    
    // 恢复原生select样式
    nativeSelect.style.position = '';
    nativeSelect.style.opacity = '';
    nativeSelect.style.pointerEvents = '';
    nativeSelect.style.width = '';
    nativeSelect.style.height = '';
    
    // 移除标记
    delete nativeSelect.dataset.enhanced;
  }
  
  // ==================== FormSelect 交互部分 ====================
  
  // 辅助函数：向上查找最近的匹配元素
  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches && el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  // 关闭所有打开的下拉菜单（除了指定的例外）
  function closeAllSelect(except) {
    document.querySelectorAll('.form-select.is-open').forEach(function (el) {
      if (el !== except) {
        el.classList.remove('is-open');
      }
    });
  }
  
  // 获取selectEl对应的dropdown
  function getDropdown(selectEl) {
    return selectEl._dropdown || selectEl.querySelector('.form-select-dropdown');
  }

  function getSearchInput(selectEl) {
    var dropdown = getDropdown(selectEl);
    if (!dropdown) return null;
    return dropdown.querySelector('.form-select-search-input');
  }

  function ensureSearchUI(selectEl, dropdown) {
    if (selectEl.getAttribute('data-searchable') !== 'true') return;
    if (!dropdown || dropdown.querySelector('.form-select-search-input')) return;

    var searchPlaceholder = selectEl.getAttribute('data-search-placeholder') || '搜索...';
    var searchBox = document.createElement('div');
    searchBox.className = 'form-select-search';

    var searchInput = document.createElement('input');
    searchInput.type = 'text';
    searchInput.className = 'form-control form-select-search-input';
    searchInput.placeholder = searchPlaceholder;
    searchInput.setAttribute('autocomplete', 'off');

    searchBox.appendChild(searchInput);
    dropdown.insertBefore(searchBox, dropdown.firstChild);
  }

  function getOrCreateNoResultEl(dropdown) {
    var noResultEl = dropdown.querySelector('.form-select-no-result');
    if (noResultEl) return noResultEl;

    noResultEl = document.createElement('div');
    noResultEl.className = 'form-select-no-result';
    noResultEl.textContent = '未找到匹配项';
    noResultEl.style.display = 'none';
    dropdown.appendChild(noResultEl);
    return noResultEl;
  }

  function filterOptions(selectEl, keyword) {
    var dropdown = getDropdown(selectEl);
    if (!dropdown) return;

    var normalizedKeyword = (keyword || '').trim().toLowerCase();
    var options = dropdown.querySelectorAll('.form-select-option');
    var visibleCount = 0;

    options.forEach(function(opt) {
      var label = (opt.dataset.label || opt.textContent || '').trim().toLowerCase();
      var matched = !normalizedKeyword || label.indexOf(normalizedKeyword) !== -1;

      if (matched) {
        opt.classList.remove('is-hidden-by-search');
        visibleCount += 1;
      } else {
        opt.classList.add('is-hidden-by-search');
      }
    });

    var noResultEl = getOrCreateNoResultEl(dropdown);
    noResultEl.style.display = visibleCount > 0 ? 'none' : 'block';
  }

  function resetSearch(selectEl) {
    var searchInput = getSearchInput(selectEl);
    if (!searchInput) return;

    searchInput.value = '';
    filterOptions(selectEl, '');
  }

  function bindSearchEvents(selectEl, dropdown) {
    if (selectEl.getAttribute('data-searchable') !== 'true') return;

    var searchInput = getSearchInput(selectEl);
    if (!searchInput || searchInput.dataset.searchBound === 'true') return;

    searchInput.dataset.searchBound = 'true';

    searchInput.addEventListener('click', function(e) {
      e.stopPropagation();
    });

    searchInput.addEventListener('mousedown', function(e) {
      e.stopPropagation();
    });

    searchInput.addEventListener('input', function() {
      filterOptions(selectEl, searchInput.value);
    });

    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        e.stopPropagation();
        if (searchInput.value) {
          searchInput.value = '';
          filterOptions(selectEl, '');
        }
      }
    });
  }

  // 更新显示的选中值
  function updateValue(selectEl) {
    var isMultiple = selectEl.dataset.multiple === 'true';
    var valueBox = selectEl.querySelector('.form-select-value');
    if (!valueBox) return;
    
    var dropdown = getDropdown(selectEl);
    if (!dropdown) return;
    
    var options = dropdown.querySelectorAll('.form-select-option');
    var selected = [];
    
    options.forEach(function (opt) {
      if (opt.classList.contains('is-selected')) {
        var label = opt.dataset.label || opt.textContent.trim();
        // 对于多选选项，需要过滤掉复选框文本
        if (isMultiple) {
          var textSpan = opt.querySelector('span');
          if (textSpan) {
            label = textSpan.textContent.trim();
          }
        }
        selected.push(label);
      }
    });
    
    var placeholder = selectEl.dataset.placeholder || '请选择';
    valueBox.textContent = selected.length ? selected.join(', ') : placeholder;
  }

  // 处理选项点击事件
  function handleOptionClick(e, selectEl, isMultiple) {
    var option = e.currentTarget;
    if (option.classList.contains('is-disabled')) return;
    
    e.preventDefault();
    
    var dropdown = getDropdown(selectEl);
    if (!dropdown) return;
    
    if (isMultiple) {
      // 多选模式：切换选中状态，阻止冒泡以保持下拉菜单打开
      e.stopPropagation();
      option.classList.toggle('is-selected');
      var checkbox = option.querySelector('.form-select-checkbox');
      if (checkbox) {
        checkbox.checked = option.classList.contains('is-selected');
      }
      updateValue(selectEl);
    } else {
      // 单选模式：清除其他选项，选中当前项，不阻止冒泡让下拉菜单自动关闭
      dropdown.querySelectorAll('.form-select-option').forEach(function (opt) {
        opt.classList.remove('is-selected');
      });
      option.classList.add('is-selected');
      updateValue(selectEl);
      // 单选模式选中后立即关闭
      selectEl.classList.remove('is-open');
      // 如果 dropdown 已移动到 body，需要手动隐藏
      if (dropdown.dataset.moved) {
        dropdown.style.display = 'none';
      }
    }
    
    // 同步到原生select并触发其change事件
    syncToNativeSelect(selectEl);
    
    // 触发自定义change事件
    var event = new CustomEvent('change', { detail: getValue(selectEl) });
    selectEl.dispatchEvent(event);
  }
  
  // 同步到原生select
  function syncToNativeSelect(selectEl) {
    var nativeSelectId = selectEl.getAttribute('data-native-select-id');
    if (!nativeSelectId) return;
    
    var nativeSelect = document.getElementById(nativeSelectId);
    if (!nativeSelect || nativeSelect.tagName !== 'SELECT') return;
    
    var isMultiple = selectEl.dataset.multiple === 'true';
    var dropdown = getDropdown(selectEl);
    if (!dropdown) return;
    
    var selectedOptions = dropdown.querySelectorAll('.form-select-option.is-selected');
    
    if (isMultiple) {
      // 多选：更新所有option的selected状态
      var selectedValues = [];
      selectedOptions.forEach(function(opt) {
        selectedValues.push(opt.dataset.value || '');
      });
      
      Array.from(nativeSelect.options).forEach(function(option) {
        option.selected = selectedValues.indexOf(option.value) !== -1;
      });
    } else {
      // 单选：设置value
      if (selectedOptions.length > 0) {
        nativeSelect.value = selectedOptions[0].dataset.value || '';
      } else {
        nativeSelect.value = '';
      }
    }
    
    // 触发原生select的change事件
    var changeEvent = new Event('change', { bubbles: true });
    nativeSelect.dispatchEvent(changeEvent);
  }

  // 获取当前选中的值
  function getValue(selectEl) {
    var isMultiple = selectEl.dataset.multiple === 'true';
    var dropdown = getDropdown(selectEl);
    if (!dropdown) return isMultiple ? { values: [], labels: [] } : { value: null, label: null };
    
    var options = dropdown.querySelectorAll('.form-select-option');
    var selected = [];
    var labels = [];
    
    options.forEach(function (opt) {
      if (opt.classList.contains('is-selected')) {
        selected.push(opt.dataset.value);
        var label = opt.dataset.label || opt.textContent.trim();
        if (isMultiple) {
          var textSpan = opt.querySelector('span');
          if (textSpan) label = textSpan.textContent.trim();
        }
        labels.push(label);
      }
    });
    
    if (isMultiple) {
      return { values: selected, labels: labels };
    } else {
      return { value: selected[0] || null, label: labels[0] || null };
    }
  }
  
  // 设置选中的值
  function setValue(selectEl, value) {
    if (!selectEl) return;
    
    var isMultiple = selectEl.dataset.multiple === 'true';
    var dropdown = getDropdown(selectEl);
    if (!dropdown) return;
    
    var options = dropdown.querySelectorAll('.form-select-option');
    
    if (isMultiple && Array.isArray(value)) {
      // 多选模式
      options.forEach(function(opt) {
        var shouldSelect = value.indexOf(opt.dataset.value) !== -1;
        if (shouldSelect) {
          opt.classList.add('is-selected');
        } else {
          opt.classList.remove('is-selected');
        }
        var checkbox = opt.querySelector('.form-select-checkbox');
        if (checkbox) checkbox.checked = shouldSelect;
      });
    } else if (!isMultiple) {
      // 单选模式
      options.forEach(function(opt) {
        if (opt.dataset.value == value) {
          opt.classList.add('is-selected');
        } else {
          opt.classList.remove('is-selected');
        }
      });
    }
    
    updateValue(selectEl);
    
    // 同步到原生select
    syncToNativeSelect(selectEl);
    
    // 触发change事件
    var event = new CustomEvent('change', { detail: getValue(selectEl) });
    selectEl.dispatchEvent(event);
  }
  
  // 清空选择
  function clear(selectEl) {
    if (!selectEl) return;
    
    var dropdown = getDropdown(selectEl);
    if (!dropdown) return;
    
    var options = dropdown.querySelectorAll('.form-select-option');
    options.forEach(function(opt) {
      opt.classList.remove('is-selected');
      var checkbox = opt.querySelector('.form-select-checkbox');
      if (checkbox) checkbox.checked = false;
    });
    
    updateValue(selectEl);
    
    // 触发change事件
    var event = new CustomEvent('change', { detail: getValue(selectEl) });
    selectEl.dispatchEvent(event);
  }

  // 处理文档点击事件（用于关闭下拉菜单）
  function handleDocumentClick(e) {
    // 获取所有打开的下拉菜单
    var openSelects = document.querySelectorAll('.form-select.is-open');
    
    openSelects.forEach(function(selectEl) {
      var dropdown = getDropdown(selectEl);
      
      // 检查点击是否在 selectEl 内部
      if (selectEl.contains(e.target)) {
        return; // 点击在 selectEl 内部（包括 trigger），不关闭
      }
      
      // 检查点击是否在 dropdown 内部（dropdown 可能已移动到 body）
      if (dropdown && dropdown.contains(e.target)) {
        return; // 点击在 dropdown 内部，不关闭（多选模式需要）
      }
      
      // 点击在外部，关闭下拉菜单
      selectEl.classList.remove('is-open');
      // 如果 dropdown 已移动到 body，需要手动隐藏
      if (dropdown && dropdown.dataset.moved) {
        dropdown.style.display = 'none';
      }
    });
  }

  // 初始化单个下拉选择控件
  function initSelect(selectEl) {
    // 防止重复初始化
    if (selectEl.dataset.initialized === 'true') return;
    
    // 跳过原生select元素（tagName为SELECT），只初始化增强后的容器
    if (selectEl.tagName === 'SELECT') return;
    
    var trigger = selectEl.querySelector('.form-select-trigger');
    var dropdown = selectEl.querySelector('.form-select-dropdown');
    
    if (!trigger || !dropdown) {
      // 只在第一次检查时警告，避免重复输出
      if (!selectEl.dataset.initWarned) {
        console.warn('form-select 缺少必需的子元素:', selectEl, '(trigger:', !!trigger, ', dropdown:', !!dropdown, ')');
        selectEl.dataset.initWarned = 'true';
      }
      return;
    }

    ensureSearchUI(selectEl, dropdown);
    bindSearchEvents(selectEl, dropdown);
    
    // 标记为已初始化
    selectEl.dataset.initialized = 'true';
    
    var isMultiple = selectEl.dataset.multiple === 'true';
    
    // 绑定触发器点击事件
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation(); // 阻止事件冒泡到 document，避免触发关闭逻辑
      
      if (selectEl.classList.contains('is-disabled')) return;
      
      var wasOpen = selectEl.classList.contains('is-open');
      
      // 先关闭所有其他下拉菜单
      document.querySelectorAll('.form-select.is-open').forEach(function(el) {
        if (el !== selectEl) {
          el.classList.remove('is-open');
          var otherDropdown = getDropdown(el);
          if (otherDropdown && otherDropdown.dataset.moved) {
            otherDropdown.style.display = 'none';
          }
        }
      });
      
      // 切换当前下拉菜单
      if (wasOpen) {
        selectEl.classList.remove('is-open');
        // 如果 dropdown 已移动到 body，需要手动隐藏
        if (dropdown.dataset.moved) {
          dropdown.style.display = 'none';
        }
      } else {
        selectEl.classList.add('is-open');
        
        // 将dropdown移动到body下（如果还没移动）
        if (!dropdown.dataset.moved) {
          document.body.appendChild(dropdown);
          dropdown.dataset.moved = 'true';
          // 保存对selectEl的引用（双向引用）
          dropdown._selectEl = selectEl;
          selectEl._dropdown = dropdown;
        }
        
        // 强制显示dropdown以便获取其实际高度
        dropdown.style.display = 'block';
        dropdown.style.visibility = 'hidden';
        dropdown.style.position = 'fixed';
        
        // 动态计算并设置dropdown的位置（使用fixed定位）
        var triggerRect = trigger.getBoundingClientRect();
        var viewportHeight = window.innerHeight;
        var viewportWidth = window.innerWidth;
        var spaceBelow = viewportHeight - triggerRect.bottom;
        var spaceAbove = triggerRect.top;
        
        // 设置dropdown宽度与trigger一致
        dropdown.style.width = triggerRect.width + 'px';
        dropdown.style.minWidth = triggerRect.width + 'px';
        
        // 固定最大高度为280px
        var maxDropdownHeight = 280;
        
        // 判断应该向下还是向上展开
        if (spaceBelow >= maxDropdownHeight || spaceBelow >= spaceAbove) {
          // 向下展开
          dropdown.style.top = (triggerRect.bottom + 8) + 'px';
          dropdown.style.bottom = 'auto';
          dropdown.style.maxHeight = Math.min(maxDropdownHeight, spaceBelow - 16) + 'px';
        } else {
          // 向上展开
          dropdown.style.bottom = (viewportHeight - triggerRect.top + 8) + 'px';
          dropdown.style.top = 'auto';
          dropdown.style.maxHeight = Math.min(maxDropdownHeight, spaceAbove - 16) + 'px';
        }
        
        // 处理水平位置，确保不超出视口
        var left = triggerRect.left;
        var right = left + triggerRect.width;
        
        if (right > viewportWidth) {
          // 如果右侧超出，调整到左对齐但不超出右边界
          left = viewportWidth - triggerRect.width - 8;
        }
        if (left < 0) {
          // 如果左侧超出，至少保持8px边距
          left = 8;
        }
        
        dropdown.style.left = left + 'px';
        dropdown.style.right = 'auto';
        
        // 恢复可见性
        dropdown.style.visibility = 'visible';
        
        // 滚动到选中项
        var selectedOption = dropdown.querySelector('.form-select-option.is-selected');
        if (selectedOption) {
          // 使用setTimeout确保dropdown已完全渲染
          setTimeout(function() {
            selectedOption.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }, 0);
        }

        if (selectEl.getAttribute('data-searchable') === 'true') {
          resetSearch(selectEl);
          var searchInput = getSearchInput(selectEl);
          if (searchInput) {
            setTimeout(function() {
              searchInput.focus();
            }, 0);
          }
        }
      }
    });
    
    // 绑定选项点击事件
    dropdown.querySelectorAll('.form-select-option').forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        handleOptionClick(e, selectEl, isMultiple);
      });
      
      // 如果是多选，为复选框单独绑定事件
      if (isMultiple) {
        var checkbox = opt.querySelector('.form-select-checkbox');
        if (checkbox) {
          checkbox.addEventListener('click', function (e) {
            e.stopPropagation(); // 阻止冒泡，保持下拉菜单打开
            // 切换选中状态
            opt.classList.toggle('is-selected');
            checkbox.checked = opt.classList.contains('is-selected');
            updateValue(selectEl);
            
            // 触发change事件
            var event = new CustomEvent('change', { detail: getValue(selectEl) });
            selectEl.dispatchEvent(event);
          });
        }
      }
    });
    
    // 初始化显示值
    updateValue(selectEl);
    
    // 监听滚动和resize事件，更新dropdown位置
    function updateDropdownPosition() {
      if (!selectEl.classList.contains('is-open')) return;
      
      var triggerRect = trigger.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      var viewportWidth = window.innerWidth;
      var spaceBelow = viewportHeight - triggerRect.bottom;
      var spaceAbove = triggerRect.top;
      
      dropdown.style.width = triggerRect.width + 'px';
      dropdown.style.minWidth = triggerRect.width + 'px';
      
      var maxDropdownHeight = 280;
      
      if (spaceBelow >= maxDropdownHeight || spaceBelow >= spaceAbove) {
        // 向下展开
        dropdown.style.top = (triggerRect.bottom + 8) + 'px';
        dropdown.style.bottom = 'auto';
        dropdown.style.maxHeight = Math.min(maxDropdownHeight, spaceBelow - 16) + 'px';
      } else {
        // 向上展开
        dropdown.style.bottom = (viewportHeight - triggerRect.top + 8) + 'px';
        dropdown.style.top = 'auto';
        dropdown.style.maxHeight = Math.min(maxDropdownHeight, spaceAbove - 16) + 'px';
      }
      
      // 处理水平位置
      var left = triggerRect.left;
      var right = left + triggerRect.width;
      
      if (right > viewportWidth) {
        left = viewportWidth - triggerRect.width - 8;
      }
      if (left < 0) {
        left = 8;
      }
      
      dropdown.style.left = left + 'px';
      dropdown.style.right = 'auto';
    }
    
    window.addEventListener('scroll', updateDropdownPosition, true);
    window.addEventListener('resize', updateDropdownPosition);
    
    // 保存清理函数的引用
    selectEl._cleanupPositionListeners = function() {
      window.removeEventListener('scroll', updateDropdownPosition, true);
      window.removeEventListener('resize', updateDropdownPosition);
    };
  }

  // DOM加载完成后初始化所有下拉选择控件
  function initAll() {
    // 1. 先增强所有原生select（如果启用自动增强）
    if (config.autoEnhance) {
      document.querySelectorAll(config.selector).forEach(function(nativeSelect) {
        if (nativeSelect.tagName === 'SELECT') {
          enhanceSelect(nativeSelect);
        }
      });
    }
    
    // 2. 初始化所有增强后的form-select容器
    document.querySelectorAll('.form-select').forEach(function(el) {
      if (el.tagName !== 'SELECT') {
        initSelect(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    // DOM 已经加载完成，立即初始化
    initAll();
  }
  
  // 立即绑定全局点击事件（不需要等待 DOMContentLoaded）
  document.addEventListener('click', handleDocumentClick);

  // 支持动态渲染自动初始化（MutationObserver）
  if (window.MutationObserver) {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            // 使用 setTimeout 延迟初始化，确保 DOM 完全构建
            setTimeout(function() {
              // 增强新添加的原生select
              if (config.autoEnhance && node.tagName === 'SELECT' && node.classList.contains('form-select')) {
                var enhanced = enhanceSelect(node);
                if (enhanced) {
                  initSelect(enhanced);
                }
              } else if (node.tagName === 'SELECT' && node.classList.contains('form-select')) {
                // 如果禁用自动增强，但手动增强了，也需要初始化
                var enhanced = node.nextElementSibling;
                if (enhanced && enhanced.classList.contains('form-select')) {
                  initSelect(enhanced);
                }
              }
              // 初始化新添加的form-select容器
              else if (node.classList && node.classList.contains('form-select') && node.tagName !== 'SELECT') {
                initSelect(node);
              }
              // 递归处理子元素
              else if (node.querySelectorAll) {
                if (config.autoEnhance) {
                  node.querySelectorAll('select.form-select').forEach(function(select) {
                    var enhanced = enhanceSelect(select);
                    if (enhanced) {
                      initSelect(enhanced);
                    }
                  });
                }
                node.querySelectorAll('.form-select').forEach(function(el) {
                  if (el.tagName !== 'SELECT') {
                    initSelect(el);
                  }
                });
              }
            }, 0);
          }
        });
      });
    });
    
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        if (document.body) {
          observer.observe(document.body, { childList: true, subtree: true });
        }
      });
    }
  }

  // 提供外部API
  window.FormSelect = {
    getValue: getValue,
    setValue: setValue,
    clear: clear,
    updateValue: updateValue,
    init: initSelect,
    enhance: enhanceSelect,
    destroy: destroyEnhancement,
    config: config
  };
  
  // 向后兼容：提供 SelectEnhancer 别名
  window.SelectEnhancer = {
    enhance: enhanceSelect,
    destroy: destroyEnhancement,
    config: config
  };

  // jQuery 扩展支持（如果存在）
  if (window.jQuery) {
    (function($) {
      var originalVal = $.fn.val;
      $.fn.val = function(value) {
        if (this.length && this[0].classList && this[0].classList.contains('form-select') && this[0].tagName.toLowerCase() !== 'select') {
          if (typeof value === 'undefined') {
            return FormSelect.getValue(this[0]);
          } else {
            return this.each(function() {
              var selectEl = this;
              var isMultiple = selectEl.dataset.multiple === 'true';
              var dropdown = getDropdown(selectEl);
              if (!dropdown) return;
              
              var options = dropdown.querySelectorAll('.form-select-option');
              
              if (isMultiple && Array.isArray(value)) {
                options.forEach(function(opt) {
                  var shouldSelect = value.indexOf(opt.dataset.value) !== -1;
                  if (shouldSelect) {
                    opt.classList.add('is-selected');
                  } else {
                    opt.classList.remove('is-selected');
                  }
                  var checkbox = opt.querySelector('.form-select-checkbox');
                  if (checkbox) checkbox.checked = shouldSelect;
                });
              } else {
                options.forEach(function(opt) {
                  if (opt.dataset.value == value) {
                    opt.classList.add('is-selected');
                  } else {
                    opt.classList.remove('is-selected');
                  }
                });
              }
              
              FormSelect.updateValue(selectEl);
              var event = new CustomEvent('change', { detail: FormSelect.getValue(selectEl) });
              selectEl.dispatchEvent(event);
            });
          }
        }
        return originalVal.apply(this, arguments);
      };
    })(window.jQuery);
  }
})();
